<template>
  <!-- CONTENT -->
  <vx-card>
    <div class="content-container">
      <!-- HEAD -->
      <div class="flex items-center justify-start gap-2 mb-3">
        <vs-select autocomplete v-model="nav.perPage" style="width: 140px">
          <vs-select-item v-for="_perPage in perPageOpstions" :key="`perpage_${_perPage}`" :text="`${_perPage}개씩 보기`" :value="_perPage" />
        </vs-select>
        <filter-module
          :filter-keys="['시설종류', '관리방법', '소관부서']"
          :filter-types="['multi-select', 'multi-select', 'input']"
          :filter-value-options="{
          '시설종류': this.filterCodeName,
          '관리방법': ['직접관리', '위탁관리'],
        }"
          :value="nav.filter"
          @input="filterButtonInput">
        </filter-module>
        <SearchNavItemKeyword :viewLabel="true" label="" v-model="nav.searchKeyword" class="ml-auto" />
      </div>
      <h5 class="pt-2 pb-4">대상수 : {{ tableData.length }}개소</h5>

      <!-- TABLE -->
      <table>
        <colgroup>
          <col width="100" />
          <col/>
          <col/>
          <col/>
        </colgroup>
        <thead>
        <tr>
          <th>No.</th>
          <th>시설종류</th>
          <th>시설물명</th>
          <th>관리방법</th>
          <th>소관부서</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, row_i) in renderTableData" :key="row_i">
          <td>{{ (nav.currentPage - 1) * nav.perPage + row_i + 1 }}</td>
          <td>{{ row.시설종류 }}</td>
          <td>{{ row.시설물명 }}</td>
          <td>{{ row.관리방법 }}</td>
          <td>{{ row.소관부서 }}</td>
        </tr>
        <tr v-if="renderTableData.length === 0">
          <td :colspan="nav.currentTab === 'all' ? 5 : 4">표시할 데이터가 없습니다.</td>
        </tr>
        </tbody>
      </table>

      <!-- PAGINATION -->
      <div class="vs-con-table mt-10">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="nav.total" :perPage="nav.perPage" :max-items="5" v-model="nav.currentPage"></k-pagination>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import KPagination from "@/components/kPagination/kPagination";
import moment from "moment";
import FilterModule from "./FilterModule.vue";

export default {
  components: {
    FilterModule,
    SearchNav,
    SearchNavItemSelect,
    SearchNavItemKeyword,
    KPagination,
  },
  data() {
    return {
      nav: {
        currentTab: "all",

        created_at: "",
        searchYear: moment().format("YYYY"),
        searchType: "",
        searchTypeFilter: "",
        searchKeyword: "",

        filter: [{key: '시설종류', value: ['전체']}],

        perPage: 50,
        currentPage: 1,
        total: 0,
      },
      apiData: [], // api 호출로 받아온 데이터
      tableData: [], // 필터 적용 후 데이터
      renderTableData: [], // 페이징처리되어 화면에 표기될 데이터
      codes: {
        '집단급식소': 'mass_feeding_facility',
      }
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    perPageOpstions() {
      return [50, 75, 100, 125, 150];
    },
    filterCodeName () {
      return Object.keys(this.codes);
    },
    searchFieldCodes() {
      const codes = this.codes;
      if (this.nav.filter.length === 0) {
        return Object.values(codes);
      }

      const selectCodes = []
      if (this.nav.filter.length > 0) {
        for (const filter of this.nav.filter) {
          if (filter.key === "시설종류") {
            if (filter.value.includes('전체')) {
              for (const key in codes) {
                if (!selectCodes.includes(codes[key])) {
                  selectCodes.push(codes[key]);
                }
              }
            }
            else if (filter.value.length > 0) {
              for (const value of filter.value) {
                if (codes[value] && !selectCodes.includes(codes[value])) {
                  selectCodes.push(codes[value]);
                }
              }
            }
          }
        }
      }
      return selectCodes
    },
  },
  watch: {
    "nav.searchKeyword"(value) {
      if (this.nav.currentPage !== 1) this.$set(this.nav, "currentPage", 1);
      else this.setRenderTableData();
    },
    "nav.perPage"(/*value*/) {
      if (this.nav.currentPage !== 1) this.$set(this.nav, "currentPage", 1);
      else this.setRenderTableData();
    },
    "nav.currentPage"(value) {
      this.setRenderTableData();
    },
    "nav.searchYear"(value) {
      this.$set(this.nav, "currentPage", 1);
      this.loadAPI();
    },
  },
  created() {
    this.loadAPI();
  },
  methods: {
    // 검색 버튼 클릭
    handleClickSearch() {
      this.setTableData();
    },
    filterButtonInput(data) {
      this.nav.filter = data;
      this.nav.currentPage = 1;
      this.setTableData();
    },
    // 탭 이동
    moveTab(data) {
      this.nav.currentTab = data;
    },

    // 모든 데이터 불러오기
    async loadAPI() {
      const codes = Object.values(this.codes);
      const params = {
        page: this.nav.currentPage,
        perPage: 10000,
        projectId: this.projectId,
        codes,
      };
      this.$vs.loading();
      const _apiData = await this.$store.dispatch("project/LOAD_FIELD_LIST", params);
      this.apiData = _apiData.data;
      this.$vs.loading.close();

      this.setTableData();
    },
    setTableData() {
      this.tableData = [];

      const _filterData = this.apiData.filter((data) => {
        const meta = JSON.parse(data.meta);

        // codes
        if (!this.searchFieldCodes.includes(data.field_type)) return false;

        for (let i=0; i<this.nav.filter.length; i++) {
          const filter = this.nav.filter[i];

          if (filter.key === '관리방법') {
            if (filter.value.includes('전체')) {}
            else if (!filter.value.includes(meta.관리방법)) return false;

          } else if (filter.key === '소관부서') {
            if (!meta.소관부서 || meta.소관부서.indexOf(filter.value) < 0) return false;
          }
        }

        return true;
      })

      // 테이블 형식에 맞게 apiData 변형
      const _tableData = _filterData.map((data) => {
        const meta = JSON.parse(data.meta);
        const _data = {
          시설종류: this.getFieldTypeToString(data.field_type),
          시설물명: data.field_name,
          관리방법: meta.관리방법,
          소관부서: meta.소관부서,
        }
        return _data;
      });

      this.tableData = _tableData;
      this.setRenderTableData();
    },
    setRenderTableData() {
      let datas = this.tableData;

      const _total = Math.ceil(datas.length / this.nav.perPage);
      this.nav.total = _total < 1 ? 1 : _total;

      const perPage = this.nav.perPage;
      const currentPage = this.nav.currentPage;

      const start = (currentPage - 1) * perPage;
      const end = currentPage * perPage;

      this.renderTableData = datas.slice(start, end);
    },
    getFieldTypeToString(type) {
      const keys = Object.keys(this.codes);
      for (const key of keys) {
        if (this.codes[key] === type) return key;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    font-size: 14px;
    font-weight: 400;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 6px;
  }

  th {
    font-weight: 500;
    background: #fafafa;
    padding: 18px 0;
  }
}
</style>
